<template>
  <v-container :class="'ma-0 pa-0 '" fluid>
    <v-data-table
      :headers="headerValue"
      :items="items"
      fixed-header
      class="evelation-1 overflow-y-auto"
      :disable-pagination="true"
      :no-data-text="noDataText"
      hide-default-footer
      :loading="loading"
      :loading-text="$t('LoadingText')"
      :height="height"
      :sort-by.sync="currentSort"
      :sort-desc.sync="currentSortDesc"
      :custom-sort="!needCustomSort ? undefined : customSort"
      :multi-sort="multiSort"
      :must-sort="mustSort"
    >
      <template v-slot:item="props">
        <tr
          @click="updateSelectedItems(props.item)"
          :class="getColor(props.item)"
          :ref="setRef(props.item[itemKey])"
        >
          <td v-for="header in props.headers" :key="header.value">
            <v-checkbox
              v-if="header.value === '0'"
              class="ml-2 mt-2  pa-0"
              :value="getCheckValue(props.item[itemKey])"
            />

            <v-row v-else-if="header.value === 'productsCount'">
              <v-icon v-if="props.item['productsCount'] === undefined"
                >Empty</v-icon
              >
              <span v-else-if="props.item['productsCount']"
                >{{ props.item["productsCount"] }}
                {{ $t("Productoff").toLowerCase() }}
              </span>
            </v-row>
            <v-row v-else-if="header.value === 'typeId'">
              <span>{{
                $t("referenceBooks.users.types.usType" + props.item.typeId)
              }}</span>
            </v-row>

            <v-row v-else-if="header.value === 'roles'">
              {{
                $t("referenceBooks.roles.Roles") +
                  " " +
                  props.item.roles.length
              }},
              {{
                $t("referenceBooks.roles.Rights") + " " + props.item.rightsCount
              }}
            </v-row>

            <Confirm
              v-else-if="header.value === 'userActions'"
              :textLable="$t('confirm.inactionTime') + ' (' + $t('minutes') + ')'"
              :title="$t('confirm.changeInactionTime') + ' ' + props.item.name"
              @ok="(text) => $emit('onChangeLogoutTime', text, props.item)"
              :icon-name="'mdi-clock-time-eight-outline'"
              :tooltipText="$t('confirm.inactionTime')"
              :hasTextField="true"
              :okText="'Save'"
              :buttonIsIcon="true"
              :cancelText="'Cancel'"
              :errRegexText="$t('confirm.mustBeDigits')"
              :textFieldPattern="'^[1-9]\\d*$'"
              class="confirm"
            />
            
            <label v-else-if="tooltipHeader != header.value">{{
              props.item[header.value]
            }}</label>
            <v-tooltip
              bottom
              v-else-if="
                tooltipKey != null &&
                  props.item[tooltipKey] != null &&
                  props.item[tooltipKey] !== 0 &&
                  header.value === tooltipHeader
              "
            >
              <template v-slot:activator="{ on }">
                <v-icon class="ml-1" color="black" dark v-on="on"
                  >mdi-eye</v-icon
                >
              </template>
              <span>{{ props.item[tooltipValue] }}</span>
            </v-tooltip>
          </td>
        </tr>
      </template>
    </v-data-table>
  </v-container>
</template>
<script>
import Confirm from '@/components/Confirm';
export default {
  components: {
    Confirm,
  },
  props: {
    needCustomSort: {
      type: Boolean,
      default: true,
    },
    sortByRequest: {
      type: Boolean,
      default: false,
    },
    defaultSortColumn: {
      type: String,
      default: '',
    },
    colorDefault: {
      type: String,
      default: 'white',
    },
    colorDarkDefault: {
      type: String,
      default: '#1E1E1E',
    },
    colorSelect: {
      type: String,
      default: 'blue lighten-4',
    },
    colorDarkSelect: {
      type: String,
      default: 'grey',
    },
    colorChange: {
      type: String,
      default: 'blue lighten-4',
    },
    colorDarkChange: {
      type: String,
      default: 'grey',
    },
    headers: Array,
    items: Array,
    noDataText: {
      type: String,
      default: '',
    },
    loading: {
      type: Boolean,
      default: false,
    },
    height: {
      type: String,
      default: '',
    },
    singleSelect: {
      type: Boolean,
      default: false,
    },
    itemKey: {
      type: String,
      default: null,
    },
    markedItems: {
      // элементы с подсветкой
      type: Array,
      default: null,
    },
    multiple: {
      type: Boolean,
      default: false,
    },
    selectedItems: {
      type: Array,
      default: null,
    },
    tooltipKey: {
      type: String,
      default: null,
    },
    tooltipHeader: {
      type: String,
      default: null,
    },
    tooltipValue: {
      type: String,
      default: '',
    },
    multiSort: {
      type: Boolean,
      default: false,
    },
    mustSort: {
      type: Boolean,
      default: false,
    },
    sortBy: {
      defaultItems: [],
    },
    sortDesc: {
      type: Array,
      defaultItems: [],
    },
  },
  data() {
    return {
      checkBoxType: {
        value: '0',
        width: '28px',
      },
      headerValue: [],
      selectedItemsTemp: [],
      scrollOptions: {
        duration: 0,
        offset: 10,
        easing: 'linear',
      },

      currentSortDesc: [],
      flagInSortDesc: true,
      flagOutSortDesc: true,

      lastSort: '',

      currentSort: [],
      flagInSort: true,
      flagOutSort: true,
    };
  },
  watch: {
    sortDesc() {
      if (this.flagOutSortDesc) {
        this.flagInSortDesc = false;
        this.currentSortDesc = this.sortDesc;
      } else this.flagOutSortDesc = true;
    },
    currentSortDesc() {
      if (this.flagInSortDesc) {
        this.flagOutSortDesc = false;
        this.$emit('changedSortDesc', this.currentSortDesc);
      } else this.flagInSortDesc = true;
    },
    sortBy() {
      if (this.flagOutSort) {
        this.flagInSort = false;
        this.currentSort = this.sortBy;
      } else this.flagOutSort = true;
    },
    currentSort() {
      if (this.flagInSort) {
        this.flagOutSort = false;

        if (this.currentSort.length != 0) this.lastSort = this.currentSort[0];
        else this.restoreSort();
        this.$emit('changedSort', this.currentSort);
      } else {
        this.flagInSort = true;
      }
    },

    markedItems() {
      if (this.markedItems != null && this.markedItems.length != 0) {
        const ref = this.$refs[
          `ref${this.markedItems[this.markedItems.length - 1]}`
        ];
        this.scroll(ref);
      }
    },
    headers() {
      this.setHeaders();
    },
  },
  computed: {
    isDark() {
      return this.$vuetify.theme.dark;
    }
  },
  methods: {
    setDefaultSort() {
      if (this.defaultSortColumn == '') return;
      this.currentSort.splice(0, 0, this.defaultSortColumn);
      this.currentSortDesc.splice(0, 0, false);
    },
    restoreSort() {
      this.currentSort.splice(0, 0, this.lastSort);
      this.currentSortDesc = [false];
    },
    setRef(itemValue) {
      const res = `ref${itemValue}`;

      return res;
    },
    getCheckValue(keyValue) {
      let flag = false;

      for (let i = 0; !flag && i < this.selectedItems.length; i++)
        flag = this.selectedItems[i][this.itemKey] == keyValue;

      return flag;
    },
    updateSelectedItems(item) {
      const index = this.selectedItems.indexOf(item);
      this.selectedItemsTemp = this.selectedItems;

      if (index != -1) this.removeItem(index);
      else this.addItem(item);

      this.$emit('update', this.selectedItemsTemp);
    },
    removeItem(index) {
      this.selectedItems.splice(index, 1);
    },
    addItem(item) {
      if (!this.multiple && this.selectedItems.length != 0)
        this.selectedItems.shift();

      this.selectedItems.push(item);
    },
    scroll(ref) {
      this.$vuetify.goTo(ref, this.scrollOptions);
    },
    setHeaders() {
      this.headerValue = [];
      if (this.singleSelect && this.headers[0].value != '0')
        this.headerValue.push(this.checkBoxType);
      this.headerValue = this.headerValue.concat(this.headers);
    },
    getColor(item) {
      if (
        this.selectedItems !== null &&
        this.selectedItems.length !== 0 &&
        this.selectedItems.indexOf(item) !== -1
      )
        return this.isDark ? this.colorDarkSelect : this.colorSelect;

      if (this.itemKey == null)
        return this.isDark ? this.colorDarkDefault : this.colorDefault;

      if (
        this.markedItems !== null &&
        this.markedItems.length !== 0 &&
        this.markedItems.indexOf(item[this.itemKey]) != -1
      )
        return this.isDark ? this.colorDarkChange : this.colorChange;

      return this.isDark ? this.colorDarkDefault : this.colorDefault;
    },
    customSort: function(items, sortBy, desc) {
      if (items !== null)
        // сортировка происходит в родительском элементе
        return items;

      if (sortBy === null || sortBy === undefined)
        return items.sort((a, b) => {
          return a === b ? 0 : a > b ? 1 : -1;
        });

      return items.sort((a, b) => {
        let index = 0;
        while (index < sortBy.length) {
          const isDesc =
            desc !== null && desc[index] !== null && desc[index] === true
              ? true
              : false;

          if (a[sortBy[index]] > b[sortBy[index]]) return isDesc ? -1 : 1;
          if (a[sortBy[index]] < b[sortBy[index]]) return isDesc ? 1 : -1;

          index++;
        }

        return 0;
      });
    },
  },
  async mounted() {
    this.setDefaultSort();
    await this.setHeaders();
    this.currentSort = this.sortBy;
    this.currentSortDesc = this.sortDesc;
  },
};
</script>
<style>
  .darkBackground {
    background: #1e1e1e;
  }
  .confirm {
    word-break: normal;    /* По умолчанию перенос не ломает слова */
white-space: normal;   /* Позволяет перенос строк */
overflow-wrap: break-word; /* Перенос строки по словам при необходимости */

  }
</style>
